import React, { FC } from 'react';
import { Lawyer } from '../../entity/entity.types';
import { LawyerList } from '../../entity/entity-lists/LawyerList';
import {
  ModalScrollableHeader,
  ModalScrollableContent,
  ModalScrollableContainer,
  ModalScrollableBody,
} from '../../components/modal';

type Props = {
  lawyers: Lawyer[];
  source: string;
  getEntityTitle: Function;
  getEntitySubtitle: Function;
  onRequestClose: () => void;
  isOpen: boolean;
};

export const AllLawFirmLawyersModal: FC<Props> = ({
  lawyers,
  onRequestClose = () => {},
  isOpen = false,
  getEntityTitle,
  getEntitySubtitle,
  source,
}) => {
  return (
    <ModalScrollableContainer isOpen={isOpen} onRequestClose={onRequestClose}>
      <ModalScrollableHeader
        title="Avocats dans ce cabinet"
        onClose={onRequestClose}
      />
      <ModalScrollableContent>
        <ModalScrollableBody>
          <LawyerList
            lawyers={lawyers}
            source={`${source}_modal_list`}
            getEntityTitle={getEntityTitle}
            getEntitySubtitle={getEntitySubtitle}
            fromModal
          />
        </ModalScrollableBody>
      </ModalScrollableContent>
    </ModalScrollableContainer>
  );
};
